import { render, staticRenderFns } from "./AllDossiers.vue?vue&type=template&id=47c56aeb&"
import script from "./AllDossiers.vue?vue&type=script&lang=ts&"
export * from "./AllDossiers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports